import React from 'react';
import { cn } from '../../lib/utils';
import { useTheme } from '../../contexts/ThemeContext';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' | 'xxxxl' | 'xxxxxl' | 'hugel';
  variant?: 'default' | 'monochrome' | 'inverted' | 'adaptive';
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8', 
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
  xxl: 'h-24 w-24',
  xxxl: 'h-32 w-32',
  xxxxl: 'h-40 w-40',
  xxxxxl: 'h-48 w-48',
  hugel: 'h-64 w-64'
};

const Logo: React.FC<LogoProps> = ({ 
  className, 
  size = 'lg', 
  variant = 'adaptive' 
}) => {
  const { theme } = useTheme();
  const logoClasses = cn(
    sizeClasses[size],
    className
  );

  // Get the appropriate logo file based on theme and variant
  const getLogoSource = () => {
    const logoPath = (() => {
      if (variant === 'adaptive') {
        return theme === 'dark' ? '/logo-dark.svg' : '/logo-light.svg';
      }
      
      if (variant === 'inverted') {
        return theme === 'dark' ? '/logo-light.svg' : '/logo-dark.svg';
      }
      
      if (variant === 'monochrome') {
        return '/logo-light.svg'; // Use light version for monochrome
      }
      
      // Default variant - use theme-appropriate logo
      return theme === 'dark' ? '/logo-dark.svg' : '/logo-light.svg';
    })();
    
    return logoPath;
  };

  return (
    <div className={logoClasses}>
      <img 
        key={`logo-${theme}-${variant}`}
        src={getLogoSource()} 
        alt="Pango Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default Logo;
